import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { opportunitiesAPI } from '../services/api';
import { OpportunityCard } from '../components/Card';
import Modal from '../components/Modal';
import './ListPage.css';

export default function Opportunities() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [type, setType] = useState('');
  const [page, setPage] = useState(1);
  const [applyTarget, setApplyTarget] = useState(null);
  const [form, setForm] = useState({ cover_letter: '', cv_url: '' });
  const [sending, setSending] = useState(false);
  const [toast, setToast] = useState('');

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await opportunitiesAPI.list({ search, type, page });
      setItems(data.data);
      setMeta(data.meta);
    } catch {}
    finally { setLoading(false); }
  }, [search, type, page]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleApply = async (e) => {
    e.preventDefault();
    if (!user) { window.location.href = '/login'; return; }
    setSending(true);
    try {
      const { data } = await opportunitiesAPI.apply(applyTarget.id, form);
      setToast(data.message);
      setApplyTarget(null);
      setForm({ cover_letter: '', cv_url: '' });
    } catch (err) {
      setToast(err.response?.data?.message || 'Erreur lors de la candidature.');
    } finally { setSending(false); }
  };

  return (
    <div className="list-page">
      <div className="page-header">
        <h1>Opportunités</h1>
        <p>Les opportunités en circulation dans l'écosystème YesNeDni.</p>
      </div>

      <div className="filters">
        <input
          type="text"
          placeholder="Rechercher une opportunité..."
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          className="search-input"
        />
        <select value={type} onChange={(e) => { setType(e.target.value); setPage(1); }} className="filter-select">
          <option value="">Tous types</option>
          <option value="emploi">Emploi</option>
          <option value="stage">Stage</option>
          <option value="bourse">Bourse</option>
          <option value="appel_projet">Appel à projet</option>
        </select>
      </div>

      {loading ? (
        <div className="loading">Chargement...</div>
      ) : items.length === 0 ? (
        <div className="empty">Aucune opportunité trouvée.</div>
      ) : (
        <div className="grid-2">
          {items.map((item) => (
            <OpportunityCard key={item.id} item={item} onApply={setApplyTarget} />
          ))}
        </div>
      )}

      {meta.last_page > 1 && (
        <div className="pagination">
          {Array.from({ length: meta.last_page }, (_, i) => i + 1).map((p) => (
            <button key={p} onClick={() => setPage(p)} className={`page-btn ${p === page ? 'active' : ''}`}>{p}</button>
          ))}
        </div>
      )}

      {toast && <div className="toast" onClick={() => setToast('')}>{toast}</div>}

      {applyTarget && (
        <Modal title={`Postuler — ${applyTarget.title}`} onClose={() => setApplyTarget(null)}>
          <form onSubmit={handleApply} className="modal-form">
            <label>Lettre de motivation</label>
            <textarea
              rows={5}
              value={form.cover_letter}
              onChange={(e) => setForm({ ...form, cover_letter: e.target.value })}
              placeholder="Présentez votre motivation (optionnel)..."
            />
            <label>Lien CV (URL)</label>
            <input
              type="url"
              value={form.cv_url}
              onChange={(e) => setForm({ ...form, cv_url: e.target.value })}
              placeholder="https://drive.google.com/... (optionnel)"
            />
            <button type="submit" className="btn-submit" disabled={sending}>
              {sending ? 'Envoi...' : 'Envoyer ma candidature'}
            </button>
          </form>
        </Modal>
      )}
    </div>
  );
}
